import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import EastIcon from '@mui/icons-material/East';
// import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LockIcon from '@mui/icons-material/Lock';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import YouTubeIcon from '@mui/icons-material/YouTube';
// import PhoneIcon from '@mui/icons-material/Phone';
import {
  Box,
  Container,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import CustomButton from '@/components/ui/CustomButton';
import { globalAssignRefName } from '@/utils/utils';

interface Props {
  onSidebarOpen: () => void;
  onRightSidebarOpen: () => void;
}

const Header = ({ onSidebarOpen }: Props) => {
  const router = useRouter();

  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [showFormsMenu, setShowFormsMenu] = useState(false);
  const [formsMenuClass, setFormsMenuClass] = useState('');
  // const tooleMenuAnchorRef = React.useRef<HTMLButtonElement>(null);
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-selected-menu';
    return 'Mui-menu';
  }

  function getSubMenuActiveClassName(currentPath: string | string[]) {
    const pathName = router.pathname;
    const paths = Array.isArray(currentPath) ? currentPath : [currentPath];

    if (pathName === '/' && paths.includes('/')) {
      return 'Mui-selected-menu-sub';
    }

    if (paths.includes(pathName) && pathName !== '/')
      return 'Mui-selected-menu-sub';
    return 'Mui-menu-sub';
  }

  // const handleFormsMenuClassToggle = () => {
  //   setFormsMenuClass((prevClass) => {
  //     if (prevClass === '') {
  //       return 'forms-menu-toggle';
  //     }
  //     return '';
  //   });
  // };

  // const handleFormsMenuToggle = () => {
  //   setShowFormsMenu((prevOpen) => !prevOpen);
  //   handleFormsMenuClassToggle();
  // };

  function handleFormsMenuClose(event: React.MouseEvent<HTMLElement>) {
    if (
      (event.target as HTMLInputElement).id !== 'forms-button' &&
      (event.target as SVGElement).id !== 'forms-button-end-icon'
    ) {
      setShowFormsMenu(false);
      setFormsMenuClass('');
    }
  }

  const formsList = () => (
    <>
      <Box
        sx={{
          pt: { xs: 1, lg: 2 },
          px: { xs: 1, lg: 2 },
          height: '100%',
          maxHeight: { md: 'calc(100vh - 120px)' },
          overflowY: 'scroll',
          '& a': {
            mr: 1,
            mb: 1,
            fontSize: { lg: '11.5pt !important', xl: '11.5pt !important' },
            width: '100%',
          },
          '& a.Mui-selected-menu-sub:hover': { color: '#fff !important' },
        }}
        className="scroller"
        role="presentation"
      >
        <Grid
          container
          spacing={2}
          m={0}
          className="MuiGrid-root-width"
          sx={{ px: 2 }}
        >
          <Grid size={{ xs: 12, md: 2.4 }}>
            <>
              {/* Business Tax Section Start */}

              <Paper
                variant="outlined"
                // className="menu-highlight"
                sx={{
                  position: 'relative',
                  border: '0px solid #dedede',
                  //  borderRadius: 2,
                  // mt: 2.5,
                  // p: 1.5,
                  pb: 0.5,
                  mb: 1.5,
                  mr: 0,
                  borderRadius: 3,
                  '& a': {
                    pl: '10px !important',
                    borderColor: '#dedede',
                    borderRadius: 2,
                  },
                  '&  a:hover': {
                    color: '#8e33e1 !important',
                    backgroundColor: '#dedfe1',
                    borderColor: '#637381',
                  },
                  '& a button': { transition: 'all 0.3s ease' },
                  '& a:hover button': { transform: 'translateX(5px)' },
                  '& > a': {
                    p: '10px !important',
                    mr: 0,
                    mb: { lg: 0, xl: 0 },
                    border: '1px solid #dedede',
                    borderRadius: 3,
                    minHeight: { lg: 80, xl: 86 },
                  },
                  '& > a:hover': {
                    color: '#8e33e1 !important',
                    backgroundColor: '#dedfe1',
                    borderColor: '#637381',
                  },
                  '& > a:hover h6': {
                    color: '#8e33e1 !important',
                  },
                  '& > a:hover .form-icon': { backgroundColor: '#fff' },
                }}
              >
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/`}
                  sx={{}}
                >
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={1}
                    sx={{
                      mr: 0,
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      // border: '1px solid #dedede',
                      // p: 1,
                      // borderRadius: 3,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: 'none',
                          borderRadius: 50,
                          textAlign: 'center',
                          minWidth: { xs: 'inherit', sm: 36 },
                          minHeight: { xs: 'inherit', sm: 36 },
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          p: { xs: 0.5, sm: 1 },
                          transition: 'all 0.3s ease 0s',
                        }}
                        className="form-icon"
                      >
                        <img
                          src="/assets/images/business-icon-app.webp"
                          alt="Business Tax Forms"
                          width={48}
                          height={48}
                        />
                      </Box>
                    </Box>

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                          fontWeight: 600,
                          color: '#374151',
                          lineHeight: 1.2,
                          mb: 0.5,
                        }}
                      >
                        Business Tax Forms
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ color: '#637381', fontSize: 13, maxWidth: 300 }}
                      >
                        File business tax returns for Corporations, LLCs &
                        Partnerships.
                      </Typography>
                    </Box>
                    <IconButton
                      sx={{
                        alignSelf: 'center',
                        p: 0.5,
                      }}
                    >
                      <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Stack>
                </Link>

                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={0}
                  flexWrap="wrap"
                  sx={{ mt: 1, ml: 0 }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1120-s/`}
                    className={getSubMenuActiveClassName(
                      '/business-tax/efile-irs-form-1120-s'
                    )}
                  >
                    Form 1120-S
                    <Box
                      sx={{
                        position: 'absolute',
                        right: 8.5,
                        top: 7,
                        maxHeight: 18,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: 'inline-block',
                          borderRadius: 50,
                          fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                          fontWeight: 400,
                          color: '#fff',
                          px: 1,
                          py: 0.5,
                          ml: 0,
                          fontFamily: 'Roboto Condensed',
                          border: '2px solid #fff',
                        }}
                        className="support-forms"
                      >
                        Currently Due
                      </Box>
                    </Box>
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1065-online/`}
                    className={getSubMenuActiveClassName(
                      '/business-tax/efile-irs-form-1065-online'
                    )}
                  >
                    Form 1065
                    <Box
                      sx={{
                        position: 'absolute',
                        right: 8.5,
                        top: 7,
                        maxHeight: 18,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: 'inline-block',
                          borderRadius: 50,
                          fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                          fontWeight: 400,
                          color: '#fff',
                          px: 1,
                          py: 0.5,
                          ml: 0,
                          fontFamily: 'Roboto Condensed',
                          border: '2px solid #fff',
                        }}
                        className="support-forms"
                      >
                        Currently Due
                      </Box>
                    </Box>
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-california-form-100s/`}
                    className={getSubMenuActiveClassName(
                      '/business-tax/efile-california-form-100s'
                    )}
                  >
                    CA FTB - Form 100S
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-california-form-565/`}
                    className={getSubMenuActiveClassName(
                      '/business-tax/efile-california-form-565'
                    )}
                  >
                    CA FTB - Form 565
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-california-form-568/`}
                    className={getSubMenuActiveClassName(
                      '/business-tax/efile-california-form-568'
                    )}
                  >
                    CA FTB - Form 568
                  </Button>
                </Stack>
              </Paper>
            </>
            {/* Business Tax Section End */}
            <Divider sx={{ backgroundColor: '#ccc', mt: 2.5 }} />
            {/* Extension Forms Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '0px solid #dedede',
                borderRadius: 2,
                mt: 2.5,
                // pb: 0.5,
                mb: 1.5,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '&  a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 129, xl: 86 },
                },
                '& > a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#213e99 !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
              }}
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/`}
                sx={{}}
              >
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{
                    mr: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'none',
                        borderRadius: 50,
                        textAlign: 'center',
                        minWidth: { xs: 'inherit', sm: 36 },
                        minHeight: { xs: 'inherit', sm: 36 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        p: { xs: 0.5, sm: 1 },
                        transition: 'all 0.3s ease 0s',
                      }}
                      className="form-icon"
                    >
                      <img
                        src="/assets/images/extension-icon.webp"
                        alt="Extension Forms"
                        width={48}
                        height={48}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                        fontWeight: 600,
                        color: '#374151',
                        lineHeight: 1.2,
                        mb: 0.5,
                      }}
                    >
                      Extension Forms
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: 13 }}
                    >
                      Request extensions for your tax filings quickly and
                      easily.{' '}
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      alignSelf: 'center',
                      p: 0.5,
                    }}
                  >
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Link>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                flexWrap="wrap"
                sx={{ mt: 1, ml: 0 }}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online'
                  )}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                  Form 8868
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                    pr: '0 !important',
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-7004-business-tax-extension-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-7004-business-tax-extension-online'
                  )}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                  Form 7004
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-4868-personal-tax-extension-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-4868-personal-tax-extension-online'
                  )}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                  Form 4868
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-8809-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-8809-online'
                  )}
                >
                  Form 8809
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/file-irs-form-15397-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-15397-online'
                  )}
                >
                  Form 15397
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: 10,
                      maxHeight: 18,
                    }}
                  >
                    <img
                      src="/assets/images/new-mobile-tag.png"
                      alt="BOI Reporting"
                    />
                  </Box> */}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/form-7004-mobile-app/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/form-7004-mobile-app'
                  )}
                >
                  Form 7004 Mobile App
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/form-4868-mobile-app/`}
                  className={getSubMenuActiveClassName(
                    '/tax-extension/form-4868-mobile-app'
                  )}
                >
                  Form 4868 Mobile App
                </Button>
              </Stack>
            </Paper>
            {/* Extension Forms Section End */}
          </Grid>
          <Grid size={{ xs: 12, md: 2.4 }}>
            {/* Employment Tax Forms Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '0px solid #dedede',
                borderRadius: 2,
                // p: 1.5,
                // pb: 0.5,
                mb: 1.5,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '& a:hover': {
                  color: '#0a7581 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 129, xl: 86 },
                },
                '& > a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#0a7581 !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
              }}
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/`}
                sx={{ position: 'relative' }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    right: 15,
                    top: -13,
                    maxHeight: 18,
                  }}
                >
                  {/* <Box
                    component={'span'}
                    sx={{
                      display: 'inline-block',
                      borderRadius: 50,
                      fontSize: { md: 10, lg: 10, xl: 11 },
                      fontWeight: 400,
                      color: '#fff',
                      px: 1,
                      py: 0.45,
                      ml: 0,
                      fontFamily: 'Roboto Condensed',
                      border: '2px solid #fff',
                    }}
                    className="support-forms"
                  >
                    All Employment Tax Forms are Currently Due
                  </Box> */}
                </Box>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{
                    mr: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'none',
                        borderRadius: 50,
                        textAlign: 'center',
                        minWidth: { xs: 'inherit', sm: 36 },
                        minHeight: { xs: 'inherit', sm: 36 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        p: { xs: 0.5, sm: 1 },
                        transition: 'all 0.3s ease 0s',
                      }}
                      className="form-icon"
                    >
                      <img
                        src="/assets/images/employment-icon.webp"
                        alt="Employment Tax Forms"
                        width={48}
                        height={48}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                        fontWeight: 600,
                        color: '#374151',
                        lineHeight: 1.2,
                        mb: 0.5,
                      }}
                    >
                      Employment Tax Forms
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: 13 }}
                    >
                      Manage payroll and employment tax filings
                      efficiently.{' '}
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      alignSelf: 'center',
                      p: 0.5,
                    }}
                  >
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Link>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                flexWrap="wrap"
                sx={{ mt: 1, ml: 0 }}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941/`}
                  className={getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-941'
                  )}
                >
                  Form 941
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box>
                  </Box> */}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941-sp/`}
                  className={getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-941-sp'
                  )}
                >
                  Form 941-SP
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box>
                  </Box> */}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/efile-irs-form-941-x-online/`}
                  className={getSubMenuActiveClassName(
                    '/employment-tax/efile-irs-form-941-x-online'
                  )}
                >
                  Form 941-X
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-941-schedule-r/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-941-schedule-r'
                  )} `}
                >
                  Form 941 Schedule R
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box>
                  </Box> */}
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-940/`}
                  className={getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-940'
                  )}
                >
                  Form 940
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/efile-irs-form-940-amendment/`}
                  className={getSubMenuActiveClassName(
                    '/employment-tax/efile-irs-form-940-amendment'
                  )}
                >
                  Form 940 Amendment
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-943/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-943'
                  )} `}
                >
                  Form 943
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-943-x/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-943-x'
                  )} `}
                >
                  Form 943-X
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-944/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-944'
                  )} `}
                >
                  Form 944
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-945/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-945'
                  )} `}
                >
                  Form 945
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-945-x/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-945-x'
                  )} `}
                >
                  Form 945-X
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/e-file-irs-form-94x-pin-request/`}
                  className={`${getSubMenuActiveClassName(
                    '/employment-tax/e-file-irs-form-94x-pin-request'
                  )} free-tag`}
                >
                  Form 94x PIN
                </Button>
              </Stack>
            </Paper>
            {/* Employment Tax Forms Section End */}
          </Grid>
          <Grid size={{ xs: 12, md: 2.4 }}>
            {/* Exempt Org Forms Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '0px solid #dedede',
                borderRadius: 2,
                // p: 1.5,
                // pb: 0.5,
                mb: 1.5,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '& a:hover': {
                  color: '#c02652 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 129, xl: 86 },
                  height: '100%',
                },
                '& > a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#c02652 !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
              }}
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/`}
                sx={{ position: 'relative' }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    right: 15,
                    top: -13,
                    maxHeight: 18,
                  }}
                >
                  {/* <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      borderRadius: 50,
                      fontSize: { md: 10, lg: 10, xl: 11 },
                      fontWeight: 400,
                      color: '#fff',
                      px: 1,
                      py: 0.45,
                      ml: 0,
                      fontFamily: 'Roboto Condensed',
                      border: '2px solid #fff',
                    }}
                    className="support-forms"
                  >
                    All 990-series forms are Currently Due
                  </Box> */}
                </Box>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{
                    mr: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'none',
                        borderRadius: 50,
                        textAlign: 'center',
                        minWidth: { xs: 'inherit', sm: 36 },
                        minHeight: { xs: 'inherit', sm: 36 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        p: { xs: 0.5, sm: 1 },
                        transition: 'all 0.3s ease 0s',
                      }}
                      className="form-icon"
                    >
                      <img
                        src="/assets/images/nonprofit-icon.webp"
                        alt="Exempt Organizations Forms"
                        width={48}
                        height={48}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                        fontWeight: 600,
                        color: '#374151',
                        lineHeight: 1.2,
                        mb: 0.5,
                      }}
                    >
                      Exempt Org. Forms
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: 13 }}
                    >
                      Handle tax filings for exempt organizations with
                      ease.{' '}
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      alignSelf: 'center',
                      p: 0.5,
                    }}
                  >
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Link>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                flexWrap="wrap"
                sx={{ mt: 1, ml: 0 }}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=menu`}
                  target="_blank"
                  // className="free-tag"
                >
                  Form 990-N <small>(e-Postcard)</small>
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-ez/`}
                  className={getSubMenuActiveClassName([
                    '/tax-exempt/e-file-irs-form-990-ez',
                    '/tax-exempt/e-file-nonprofit-return-with-ein',
                  ])}
                >
                  Form 990-EZ
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-990'
                  )}
                >
                  Form 990
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-pf/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-990-pf'
                  )}
                >
                  Form 990-PF
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                    pr: '0 !important',
                    '&.Mui-selected-menu-sub span': {
                      color: '#ccc',
                    },
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-t/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-990-t'
                  )}
                >
                  Form 990-T
                  <Box
                    sx={
                      {
                        // position: 'absolute',
                        // right: 8.5,
                        // top: 7,
                        // maxHeight: 18,
                      }
                    }
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        // borderRadius: 50,
                        fontSize: { md: 11, lg: 12, xl: 13 },
                        fontWeight: 500,
                        color: '#c02652',
                        px: 0,
                        pt: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        lineHeight: 1.2,
                      }}
                      // className="support-forms-noani"
                    >
                      Supports related forms like 3800, 3468, 8911, and 8936.
                    </Box>
                  </Box>
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-5227/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-5227'
                  )}
                >
                  Form 5227
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: 10,
                      maxHeight: 18,
                    }}
                  >
                    <img
                      src="/assets/images/new-mobile-tag.png"
                      alt="BOI Reporting"
                    />
                  </Box> */}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-1120-pol/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-1120-pol'
                  )}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: 10,
                      maxHeight: 18,
                    }}
                  >
                    <img
                      src="/assets/images/new-mobile-tag.png"
                      alt="BOI Reporting"
                    />
                  </Box>
                  Form 1120-POL
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/efile-ftb-ca-form199-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/efile-ftb-ca-form199-online'
                  )}
                >
                  CA FTB - Form 199
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/efile-ftb-ca-form109-online/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/efile-ftb-ca-form109-online'
                  )}
                >
                  CA FTB - Form 109
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: 10,
                      maxHeight: 18,
                    }}
                  >
                    <img
                      src="/assets/images/new-mobile-tag.png"
                      alt="BOI Reporting"
                    />
                  </Box>
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-form-990-amendments/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-form-990-amendments'
                  )}
                >
                  990 Amended Returns
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/`}
                  className={`${getSubMenuActiveClassName(
                    '/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online'
                  )} `}
                >
                  990 Extension (Form 8868)
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-schedules/`}
                  className={getSubMenuActiveClassName(
                    '/tax-exempt/e-file-irs-form-990-schedules'
                  )}
                >
                  Form 990 Schedules
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}nonprofit-taxes/`}
                  className={getSubMenuActiveClassName('/nonprofit-taxes')}
                >
                  Non-Profit State Filing
                </Button>

                {/* <Box
                  sx={{
                    p: 1,
                    ml: -0.1,
                    mr: 0.8,
                    backgroundColor: '#fceeeb',
                    borderRadius: 2,
                    border: '1.2px solid #c9184a',
                  }}
                >
                  <Typography variant="body2">
                    <span style={{ fontWeight: 600, color: '#c9184a' }}>
                      {' '}
                      *Form 990 Series returns
                    </span>{' '}
                    are due <br />
                    <span style={{ fontWeight: 600, color: '#0c0c0cff' }}>
                      {' '}
                      November 17, 2025
                    </span>
                    , for June 30 year-end or extended filers.
                  </Typography>
                </Box> */}
              </Stack>
            </Paper>
            {/* Exempt Org. Forms Section End */}
          </Grid>{' '}
          <Grid size={{ xs: 12, md: 2.4 }}>
            {/* Information Returns Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '0px solid #dedede',
                borderRadius: 2,
                // p: 1.5,
                // pb: 0.5,
                mb: 1.5,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '& a:hover': {
                  color: '#4269e2 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 129, xl: 86 },
                },
                '& > a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#4269e2 !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
                '& .MuiButtonBase-root.MuiButton-root': {
                  fontSize: '14px !important',
                },
              }}
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/`}
                sx={{ position: 'relative' }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    right: 15,
                    top: -13,
                    maxHeight: 18,
                  }}
                >
                  {/* <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      borderRadius: 50,
                      fontSize: { md: 10, lg: 10, xl: 11 },
                      fontWeight: 400,
                      color: '#fff',
                      px: 1,
                      py: 0.45,
                      ml: 0,
                      fontFamily: 'Roboto Condensed',
                      border: '2px solid #fff',
                    }}
                    className="support-forms"
                  >
                    All 5498-series forms are Currently Due
                  </Box> */}
                </Box>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{
                    mr: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'none',
                        borderRadius: 50,
                        textAlign: 'center',
                        minWidth: { xs: 'inherit', sm: 36 },
                        minHeight: { xs: 'inherit', sm: 36 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        p: { xs: 0.5, sm: 1 },
                        transition: 'all 0.3s ease 0s',
                      }}
                      className="form-icon"
                    >
                      <img
                        src="/assets/images/information-icon.webp"
                        alt="Information Returns"
                        width={48}
                        height={48}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                        fontWeight: 600,
                        color: '#374151',
                        lineHeight: 1.2,
                        mb: 0.5,
                      }}
                    >
                      Information Returns
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: 13 }}
                    >
                      Accurately report information return forms (W-2, 1099,
                      1098).
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      alignSelf: 'center',
                      p: 0.5,
                    }}
                  >
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Link>
              <Grid container spacing={2} sx={{ mt: -1, pt: '0 !important' }}>
                <Grid size={{ xs: 12, md: 4 }} sx={{ '& a': { fontSize: 11 } }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w2/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-w2'
                    )}
                  >
                    Form W-2
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w2-c/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-w2-c'
                    )}
                  >
                    Form W-2c
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-nec/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-nec'
                    )}
                  >
                    1099-NEC
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-misc/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-misc'
                    )}
                  >
                    1099-MISC
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-int/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-int'
                    )}
                  >
                    1099-INT
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-div/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-div'
                    )}
                  >
                    1099-DIV
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-a/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-a'
                    )}
                  >
                    1099-A
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-da/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-da'
                    )}
                  >
                    1099-DA
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-b/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-b'
                    )}
                  >
                    1099-B
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-k/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-k'
                    )}
                  >
                    1099-K
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-g/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-g'
                    )}
                  >
                    1099-G
                  </Button>

                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-w2-state-filing/`}
                    className={getSubMenuActiveClassName(
                      '/form-w2-state-filing'
                    )}
                  >
                    W-2 State Filing
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-1099-state-filing/`}
                    className={getSubMenuActiveClassName(
                      '/form-1099-state-filing'
                    )}
                  >
                    1099 State Filing
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-r/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-r'
                    )}
                  >
                    1099-R
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-c/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-c'
                    )}
                  >
                    1099-C
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-s/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-s'
                    )}
                  >
                    1099-S
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-sa/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-sa'
                    )}
                  >
                    1099-SA
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-ltc/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-ltc'
                    )}
                  >
                    1099-LTC
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-oid/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-oid'
                    )}
                  >
                    1099-OID
                  </Button>

                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-patr/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-patr'
                    )}
                  >
                    1099-PATR
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-q/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-q'
                    )}
                  >
                    1099-Q
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-w-2g/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-w-2g'
                    )}
                  >
                    W-2G
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1097-btc/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1097-btc'
                    )}
                  >
                    1097-BTC
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1042-s/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1042-s'
                    )}
                  >
                    1042-S
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-3921/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-3921'
                    )}
                  >
                    3921
                  </Button>

                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1099-corrections/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1099-corrections'
                    )}
                  >
                    1099 Corrections
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                  {/* </Box> */}
                  {/* <Box
                    className="support-forms"
                    sx={{
                      p: '1px',
                      borderRadius: '8px !important',
                      height: 'auto',
                      mb: 1,
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    // sx={{
                    //   textTransform: 'none',
                    //   borderRadius: '8px !important',
                    //   backgroundColor: '#fff',
                    //   border: '0 !important',
                    //   mb: '0px !important',
                    // }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-5498'
                    )}
                  >
                    5498
                  </Button>
                  {/* </Box>
                  <Box
                    className="support-forms"
                    sx={{
                      p: '1px',
                      borderRadius: '8px !important',
                      height: 'auto',
                      mb: 1,
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    // sx={{
                    //   textTransform: 'none',
                    //   borderRadius: '8px !important',
                    //   backgroundColor: '#fff',
                    //   border: '0 !important',
                    //   mb: '0px !important',
                    // }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-esa/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-5498-esa'
                    )}
                  >
                    5498-ESA
                  </Button>
                  {/* </Box>
                  <Box
                    className="support-forms"
                    sx={{
                      p: '1px',
                      borderRadius: '8px !important',
                      height: 'auto',
                      mb: 1,
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    // sx={{
                    //   textTransform: 'none',
                    //   borderRadius: '8px !important',
                    //   backgroundColor: '#fff',
                    //   border: '0 !important',
                    //   mb: '0px !important',
                    // }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-sa/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-5498-sa'
                    )}
                  >
                    5498-SA
                  </Button>
                  {/* </Box>
                  <Box
                    className="support-forms"
                    sx={{
                      p: '1px',
                      borderRadius: '8px !important',
                      height: 'auto',
                      mb: 1,
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    // sx={{
                    //   textTransform: 'none',
                    //   borderRadius: '8px !important',
                    //   backgroundColor: '#fff',
                    //   border: '0 !important',
                    //   mb: '0px !important',
                    // }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-5498-qa/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-5498-qa'
                    )}
                  >
                    5498-QA
                  </Button>
                  {/* </Box> */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-3922/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-3922'
                    )}
                  >
                    3922
                  </Button>

                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098'
                    )}
                  >
                    1098
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-c/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098-c'
                    )}
                  >
                    1098-C
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-e/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098-e'
                    )}
                  >
                    1098-E
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-f/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098-f'
                    )}
                  >
                    1098-F
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-t/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098-t'
                    )}
                  >
                    1098-T
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 1.5 }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/efile-irs-form-1098-q/`}
                    className={getSubMenuActiveClassName(
                      '/information-returns/efile-irs-form-1098-q'
                    )}
                  >
                    1098-Q
                  </Button>
                  {/* <Box
                    component={'div'}
                    // className="aca-forms"
                    className="menu-highlight"
                    sx={{
                      position: 'relative',
                      // border: '1px solid #dedede',
                      //  borderRadius: 2,
                      px: 0,
                      // pb: 0.5,
                      mb: 1,
                      mr: 0,
                      borderRadius: 2,
                      zIndex: 0,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: -2,
                        left: -3,
                        width: 'calc(100% + 6px)',
                        height: 'calc(100% + 4px)',
                        borderRadius: '12px',

                        background:
                          'linear-gradient(45deg,#ff0000,#ff7300,#fffb00,#48ff00,#00ffd5,#002bff,#7a00ff,#ff00c8,#ff0000)',
                        backgroundSize: '400%',

                        animation: 'glowing 20s linear infinite',

                        zIndex: -1, // now works correctly
                      },

                      '@keyframes glowing': {
                        '0%': { backgroundPosition: '0 0' },
                        '50%': { backgroundPosition: '400% 0' },
                        '100%': { backgroundPosition: '0 0' },
                      },
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      backgroundColor: '#fff',
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}aca-forms/e-file-form-1095b/`}
                    className={getSubMenuActiveClassName(
                      '/aca-forms/e-file-form-1095b'
                    )}
                  >
                    1095-B
                  </Button>
                  {/* </Box> */}
                  {/* <Box
                    component={'div'}
                    
                    className="menu-highlight"
                    sx={{
                      position: 'relative',
                      
                      px: 0,
                      
                      mb: 1,
                      mr: 0,
                      borderRadius: 2,
                      zIndex: 0,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: -2,
                        left: -3,
                        width: 'calc(100% + 6px)',
                        height: 'calc(100% + 4px)',
                        borderRadius: '12px',

                        background:
                          'linear-gradient(45deg,#ff0000,#ff7300,#fffb00,#48ff00,#00ffd5,#002bff,#7a00ff,#ff00c8,#ff0000)',
                        backgroundSize: '400%',

                        animation: 'glowing 20s linear infinite',

                        zIndex: -1, // now works correctly
                      },

                      '@keyframes glowing': {
                        '0%': { backgroundPosition: '0 0' },
                        '50%': { backgroundPosition: '400% 0' },
                        '100%': { backgroundPosition: '0 0' },
                      },
                    }}
                  > */}
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: 1.5,
                      backgroundColor: '#fff',
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}aca-forms/e-file-form-1095c/`}
                    className={getSubMenuActiveClassName(
                      '/aca-forms/e-file-form-1095c'
                    )}
                  >
                    1095-C
                  </Button>
                </Grid>
              </Grid>
            </Paper>
            {/* Information Returns Forms Section End */}
          </Grid>
          <Grid size={{ xs: 12, md: 2.4 }}>
            {/* Excise Tax Forms Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '0px solid #dedede',
                borderRadius: 2,
                // p: 1.5,
                // pb: 0.5,
                mb: 1.5,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '& a:hover': {
                  color: '#1b6f36 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 129, xl: 86 },
                },
                '& > a:hover': {
                  color: '#213e99 !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#1b6f36 !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
              }}
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/`}
                sx={{}}
              >
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{
                    mr: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'none',
                        borderRadius: 50,
                        textAlign: 'center',
                        minWidth: { xs: 'inherit', sm: 36 },
                        minHeight: { xs: 'inherit', sm: 36 },
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        p: { xs: 0.5, sm: 1 },
                        transition: 'all 0.3s ease 0s',
                      }}
                      className="form-icon"
                    >
                      <img
                        src="/assets/images/excise-icon.webp"
                        alt="Excise Tax Forms"
                        width={48}
                        height={48}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                        fontWeight: 600,
                        color: '#374151',
                        lineHeight: 1.2,
                        mb: 0.5,
                      }}
                    >
                      Excise Tax Forms
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: 13 }}
                    >
                      Handle federal excise tax, HVUT reporting and payment with
                      ease.{' '}
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      alignSelf: 'center',
                      p: 0.5,
                    }}
                  >
                    <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Link>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                flexWrap="wrap"
                sx={{ mt: 1, ml: 0 }}
              >
                {/* <Box
                  className="boi-forms"
                  sx={{
                    p: '1px',
                    borderRadius: '8px !important',
                    height: 'auto',
                    mb: 1,
                    width: '100%',
                  }}
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: 'none',

                      borderRadius: '8px !important',
                      backgroundColor: '#fff',
                      border: '0 !important',
                      mb: '0px !important',
                    }}
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/pre-file-form-2290/`}
                    className={getSubMenuActiveClassName(
                      '/excise-tax/pre-file-form-2290'
                    )}
                  >
                    Pre-File Form 2290
                  </Button>
                </Box> */}
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',

                    borderRadius: '8px !important',
                    // backgroundColor: '#fff',
                    // border: '0 !important',
                    // mb: '0px !important',
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/file-irs-form-2290-by-phone/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/file-irs-form-2290-by-phone'
                  )}
                >
                  Phone Filing Form 2290
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{
                    textTransform: 'none',

                    borderRadius: '8px !important',
                    // backgroundColor: '#fff',
                    // border: '0 !important',
                    // mb: '0px !important',
                  }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online'
                  )}
                >
                  Form 2290
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8.5,
                      top: 7,
                      maxHeight: 18,
                    }}
                  >
                    {/* <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        borderRadius: 50,
                        fontSize: { md: 10, lg: 10.5, xl: 11.5 },
                        fontWeight: 400,
                        color: '#fff',
                        px: 1,
                        py: 0.5,
                        ml: 0,
                        fontFamily: 'Roboto Condensed',
                        border: '2px solid #fff',
                      }}
                      className="support-forms"
                    >
                      Currently Due
                    </Box> */}
                  </Box>
                </Button>

                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-8849-schedule-6-online/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/efile-irs-form-8849-schedule-6-online'
                  )}
                >
                  Form 8849
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/free-e-file-form-2290-suspended-vehicles/`}
                  className={`${getSubMenuActiveClassName(
                    '/excise-tax/free-e-file-form-2290-suspended-vehicles'
                  )} `}
                >
                  Suspended Vehicles
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-vin-correction-online/`}
                  className={`${getSubMenuActiveClassName(
                    '/excise-tax/efile-irs-form-2290-vin-correction-online'
                  )} free-tag`}
                >
                  VIN Correction
                </Button>
                {/* <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-weight-increased-amendment/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/efile-irs-form-2290-weight-increased-amendment'
                  )}
                >
                  Weight Increased
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-mileage-exceeded-amendment/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/efile-irs-form-2290-mileage-exceeded-amendment'
                  )}
                >
                  Mileage Exceeded
                </Button> */}
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/click2file-form-2290/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/click2file-form-2290'
                  )}
                >
                  Form 2290 Click2File
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/form-2290-mobile-app/`}
                  className={getSubMenuActiveClassName(
                    '/excise-tax/form-2290-mobile-app'
                  )}
                >
                  Form 2290 Mobile App
                </Button>
              </Stack>
            </Paper>
            {/* Excise Tax Forms Section End */}
            <Divider sx={{ backgroundColor: '#ccc', mb: 2.5 }} />
            {/* Essential Forms Section Start */}
            <Paper
              variant="outlined"
              sx={{
                border: '1px solid #dedede',
                //  borderRadius: 2,
                p: 1.5,
                pb: 0.5,
                // mb: 1.5,
                mr: 0,
                borderRadius: 3,
                '& a': {
                  pl: '10px !important',
                  borderColor: '#dedede',
                  borderRadius: 2,
                },
                '&  a:hover': {
                  color: '#4b42ad !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& a button': { transition: 'all 0.3s ease' },
                '& a:hover button': { transform: 'translateX(5px)' },
                '& > a': {
                  p: '10px !important',
                  mr: 0,
                  mb: { lg: 0, xl: 0 },
                  border: '1px solid #dedede',
                  borderRadius: 3,
                  minHeight: { lg: 80, xl: 86 },
                },
                '& > a:hover': {
                  color: '#4b42ad !important',
                  backgroundColor: '#dedfe1',
                  borderColor: '#637381',
                },
                '& > a:hover h6': {
                  color: '#4b42ad !important',
                },
                '& > a:hover .form-icon': { backgroundColor: '#fff' },
              }}
            >
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: 'none',
                      borderRadius: 50,
                      textAlign: 'center',
                      minWidth: { xs: 'inherit', sm: 36 },
                      minHeight: { xs: 'inherit', sm: 36 },
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      p: { xs: 0.5, sm: 1 },
                      transition: 'all 0.3s ease 0s',
                    }}
                    className="form-icon"
                  >
                    <img
                      src="/assets/images/other-icon.webp"
                      alt="Essential Forms"
                      width={48}
                      height={48}
                    />
                  </Box>
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                      fontWeight: 600,
                      color: '#374151',
                      lineHeight: 1.2,
                      mb: 0.5,
                    }}
                  >
                    Essential Forms
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ color: '#637381', fontSize: 13 }}
                  >
                    Easily manage key IRS forms like Form W-9, Form W-8BEN, Form
                    8655, FinCEN BOIR and more.
                  </Typography>
                </Box>
              </Stack>

              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={0}
                flexWrap="wrap"
                sx={{ mt: 2, ml: 0 }}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}request-form-w9-online-free/`}
                  className={`${getSubMenuActiveClassName(
                    '/request-form-w9-online-free'
                  )} free-tag`}
                >
                  Form W-9
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}request-form-w8ben-online-free/`}
                  className={`${getSubMenuActiveClassName(
                    '/request-form-w8ben-online-free'
                  )} free-tag`}
                >
                  Form W-8BEN
                </Button>

                {/* <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}form-8655/`}
                  className={getSubMenuActiveClassName('/form-8655')}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: 10,
                      maxHeight: 18,
                    }}
                  >
                    <img
                      src="/assets/images/new-mobile-tag.png"
                      alt="BOI Reporting"
                    />
                  </Box>
                  Form 8655
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: 'none', borderRadius: 1.5 }}
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}efile-boi-report/`}
                  className={getSubMenuActiveClassName('/efile-boi-report')}
                >
                  BOI Report
                </Button> */}
              </Stack>
            </Paper>
            {/* Essential Forms Section End */}
          </Grid>
        </Grid>
      </Box>
      {/* <Box className="medium-scoller-fix"></Box> */}
    </>
  );

  const resourcesList = () => (
    <>
      <Box sx={{ pl: { lg: 0, xl: 0 }, py: { xs: 0, xl: 0 } }}>
        <Grid container spacing={0} sx={{ pt: 0 }}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ pt: 1, pl: 2 }}>
            <Box sx={{ pr: 2, mt: 1.5, mb: 0 }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: { md: 18, sm: 17 },
                  color: '#333',
                  fontWeight: 600,
                  mb: 0,
                }}
              >
                Tools & Calculators
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 13,
                  color: '#637381',
                  mb: 2,
                  mr: 0,
                }}
              >
                Quickly calculate taxes and find deadline with our trusted
                tools.
              </Typography>
            </Box>
            {/* <Stack spacing={2} direction={'column'} sx={{ pl: 2 }}> */}
            <Box
              sx={{
                pr: 2,
                '& .resoucres-new': {
                  px: '0px !important',
                  py: '0px !important',
                },
              }}
            >
              {/* Start 2290 Tax Calculator */}

              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tools/form-2290-tax-calculator/`}
                className="resoucres-new"
                sx={{
                  textDecoration: 'none',
                }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 1.2,
                    py: 1,
                    borderRadius: 2,
                    background: '#e7f8ed',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    mx: 0,
                    justifyContent: 'space-between',
                    // gridTemplateColumns: 'auto auto ',
                    // columnGap: 1,
                    // maxWidth: '100%',
                    // margin: 'auto',
                    transition: 'all 0.3s ease 0s',
                    '& .arrow-icon': {
                      transition: 'all 0.3s ease 0s',
                      position: 'relative',
                      left: -6,
                    },
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 25px',
                      backgroundColor: '#fff',
                    },
                    '&:hover .arrow-icon': { left: 0 },
                  }}
                >
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      // margin: 0,
                      // justifyContent: 'center',
                      // textAlign: 'left',
                      // mt: 0.5,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tax-calc-icon.webp" />
                      <source srcSet="/assets/images/tax-calc-icon.png" />
                      <img
                        src="/assets/images/tax-calc-icon.png"
                        alt="Form 2290 Tax Calculator"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                    <Box sx={{ ml: 2 }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, fontSize: 15 }}
                      >
                        Form 2290 Tax Calculator
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 13,
                          fontWeight: 400,
                          color: '#637381',
                          lineHeight: 1.3,
                        }}
                      >
                        Estimate your HVUT quickly
                      </Typography>
                    </Box>
                  </Box>

                  <ArrowForwardIosIcon
                    sx={{
                      fontSize: 18,
                      color: '#2c2c2cff',
                      display: 'flex',
                      alignContent: 'end',
                      ml: 1.8,
                    }}
                    className="arrow-icon"
                  />
                </Paper>
              </Link>
              {/* End 2290 Tax Calculator */}
              {/* Start 990 EIN Finder */}
              <Link
                href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}`}
                target="_blank"
                className="resoucres-new"
                sx={{
                  textDecoration: 'none',
                }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 1.2,
                    py: 1,
                    borderRadius: 2,
                    background: '#f6e6ea',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    mx: 0,
                    mb: 2,
                    justifyContent: 'space-between',
                    // gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    // maxWidth: '100%',
                    // margin: 'auto',
                    transition: 'all 0.3s ease 0s',
                    '& .arrow-icon': {
                      transition: 'all 0.3s ease 0s',
                      position: 'relative',
                      left: -6,
                    },
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 25px',
                      backgroundColor: '#fff',
                    },
                    '&:hover .arrow-icon': {
                      transform: 'rotate(-35deg)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      // margin: 0,
                      // justifyContent: 'center',
                      // textAlign: 'left',
                      // mt: 0.5,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/finder-icon.webp" />
                      <source srcSet="/assets/images/finder-icon.png" />
                      <img
                        src="/assets/images/finder-icon.png"
                        alt="990 EIN Finder"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                    <Box sx={{ ml: 2 }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, fontSize: 15 }}
                      >
                        990 EIN Finder
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 13,
                          fontWeight: 400,
                          color: '#637381',
                          lineHeight: 1.3,
                        }}
                      >
                        Locate and verify nonprofit EINs with ease for IRS Form
                        990
                      </Typography>
                    </Box>
                  </Box>
                  <EastIcon sx={{ ml: 0.8 }} className="arrow-icon" />
                  {/* <ArrowForwardIosIcon
                                sx={{
                                  fontSize: 18,
                                  color: '#2c2c2cff',
                                  display: 'flex',
                                  alignSelf: 'center',
                                }}
                                className="arrow-icon"
                              /> */}
                </Paper>
              </Link>
              {/* End 990 EIN Finder */}

              {/* Start 7004 Due Date */}
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tools/form-7004-due-date-calculator/`}
                className="resoucres-new"
                sx={{
                  textDecoration: 'none',
                }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 1.2,
                    py: 1,
                    borderRadius: 2,
                    background: '#e6eaf7',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    mx: 0,
                    justifyContent: 'space-between',
                    // gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    // maxWidth: '100%',
                    // margin: 'auto',
                    transition: 'all 0.3s ease 0s',
                    '& .arrow-icon': {
                      transition: 'all 0.3s ease 0s',
                      position: 'relative',
                      left: -6,
                    },
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 25px',
                      backgroundColor: '#fff',
                    },
                    '&:hover .arrow-icon': { left: 2 },
                  }}
                >
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      // margin: 0,
                      // justifyContent: 'center',
                      // textAlign: 'left',
                      // mt: 0.5,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/due-date-icon.webp" />
                      <source srcSet="/assets/images/due-date-icon.png" />
                      <img
                        src="/assets/images/due-date-icon.png"
                        alt="Form 7004 Due Date Calculator"
                        loading="lazy"
                        width={39}
                        height={39}
                      />
                    </picture>
                    <Box sx={{ ml: 2 }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, fontSize: 15 }}
                      >
                        Form 7004 Due Date Calculator
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 13,
                          fontWeight: 400,
                          color: '#637381',
                          lineHeight: 1.3,
                        }}
                      >
                        Find the exact extension deadline
                      </Typography>
                    </Box>
                  </Box>
                  <ArrowForwardIosIcon
                    sx={{
                      fontSize: 18,
                      color: '#2c2c2cff',
                      display: 'flex',
                      alignSelf: 'center',
                    }}
                    className="arrow-icon"
                  />
                </Paper>
              </Link>
              {/* End 7004 Due Date */}
              {/* </Stack> */}
            </Box>
            <Box sx={{ mt: 3, pl: 0, mb: 1 }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: { md: 18, sm: 17 },
                  color: '#333',
                  fontWeight: 600,
                  mb: 0,
                }}
              >
                Contact & Support{' '}
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: 13, color: '#637381', mb: 0.8 }}
              >
                Reach out for personalized help
              </Typography>
            </Box>
            <Box
              sx={{
                pr: 2,
                mb: 2,
                '& .resoucres-new': {
                  px: '0px !important',
                  py: '0px !important',
                },
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 1.2,
                  py: 1,
                  borderRadius: 2,
                  background: '#CCFFF3',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  mx: 0,
                  mb: 1,
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  component="picture"
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/need-help-img.webp" />
                    <source srcSet="/assets/images/need-help-img.png" />
                    <img
                      src="/assets/images/need-help-img.png"
                      alt="Need Help?"
                      loading="lazy"
                      width={70}
                      height={60}
                    />
                  </picture>
                  <Box sx={{ ml: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 15 }}
                    >
                      Need Help?{' '}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        fontWeight: 400,
                        color: '#637381',
                        lineHeight: 1.3,
                      }}
                    >
                      we&apos;re here to help with any questions or concerns
                    </Typography>
                    <Box
                      sx={{
                        maxWidth: 120,
                        mt: 1,
                      }}
                    >
                      <Button
                        // size="medium"
                        className="primary-btn-new"
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}contact-us/`}
                        sx={{
                          mr: '0 !important',
                          px: '16px !important',
                          textAlign: 'center',
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            backgroundColor: 'rgb(23, 43, 107) !important',
                          },
                        }}
                      >
                        Contact Us
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Grid>
          <Grid
            size={{ md: 4, sm: 6, xs: 12 }}
            sx={{
              borderLeft: '1px solid #ccc',
              justifyContent: 'center',
              pl: 2,
              pt: 1,
              // display: 'flex',
              // m: 'auto',
              '& .resoucres-new > div': { borderRadius: 2 },
            }}
          >
            <Box sx={{ pl: 0, mt: 1.5, mb: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: { md: 18, sm: 17 },
                  color: '#333',
                  fontWeight: 600,
                  mb: 0,
                }}
              >
                Resources & Articles
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: 13, color: '#637381' }}
              >
                In-depth form breakdowns
              </Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',

                  // justifyContent: 'space-between',
                  // gridTemplateColumns: 'auto auto ',
                  columnGap: 1,
                  maxWidth: '100%',
                  margin: 'auto',
                  mb: 1,
                }}
              >
                <Box
                  component="img"
                  src="/assets/images/articles-icon.svg"
                  alt="Guides & How -To-Articles"
                  loading="lazy"
                />
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 15 }}
                  >
                    Guides & How -To-Articles
                  </Typography>
                </Box>
              </Paper>
              <Stack
                spacing={0}
                direction="column"
                sx={{
                  mr: 0,
                  '& .resoucres-new': {
                    px: '8px !important',
                    py: '0px !important',
                  },
                }}
              >
                <Link
                  href="https://blog.taxzerone.com/posts/how-to-renew-form-2290-for-the-2026-tax-year/"
                  target="_blank"
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="How to File IRS Form 2290 for the 2026 Tax Year?"
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,

                        fontWeight: 500,
                      }}
                    >
                      How to File IRS Form 2290 for the 2026 Tax Year?
                    </Typography>
                  </Box>
                </Link>

                <Link
                  href="https://support.taxzerone.com/bulk-upload-option-for-2290-filers-save-time-with-taxzerone/"
                  target="_blank"
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="Bulk Upload Option for 2290 Filers"
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        // mr: 1.9,
                        fontWeight: 500,
                      }}
                    >
                      Bulk Upload Option for 2290 Filers
                    </Typography>
                  </Box>
                </Link>

                <Link
                  href="https://support.taxzerone.com/why-is-form-2290-schedule-1-important/"
                  target="_blank"
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="Why is Form 2290 Schedule 1 Important? "
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        // mr: 6.5,
                        fontWeight: 500,
                      }}
                    >
                      Why is Form 2290 Schedule 1 Important?
                    </Typography>
                  </Box>
                </Link>
              </Stack>
            </Box>

            <Box>
              <Paper
                variant="outlined"
                sx={{
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  // justifyContent: 'center',
                  // justifyContent: 'space-between',
                  // gridTemplateColumns: 'auto auto ',
                  columnGap: 1,
                  maxWidth: '100%',
                  margin: 0,
                  mb: 0,
                }}
              >
                <Box
                  component="img"
                  src="/assets/images/trending-icon.svg"
                  alt="Trending Topics"
                  loading="lazy"
                />
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 15 }}
                  >
                    Trending Topics
                  </Typography>
                </Box>
              </Paper>
              <Stack
                spacing={0}
                direction="column"
                sx={{
                  mr: 0,
                  '& .resoucres-new': {
                    px: '8px !important',
                    pb: '0px !important',
                  },
                }}
              >
                <Link
                  href="https://support.taxzerone.com/how-do-i-file-a-form-2290-vin-correction/"
                  target="_blank"
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="What’s New in Form 941 for 2026 – Key Changes Explained"
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,

                        fontWeight: 500,
                      }}
                    >
                      How do I file a Form 2290 VIN Correction?
                    </Typography>
                  </Box>
                </Link>
                <Link
                  href="https://support.taxzerone.com/how-to-file-form-1120-s-for-an-s-corporation-step-by-step-guide/"
                  target="_blank"
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="How do I file Form 1120-S online?"
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,

                        fontWeight: 500,
                      }}
                    >
                      How do I file Form 1120-S online?
                    </Typography>
                  </Box>
                </Link>

                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}faqs/form-2290/`}
                  className="resoucres-new"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'left',
                      gridTemplateColumns: 'auto auto ',
                      transition: 'all 0.3s ease 0s',
                      alignItems: 'left',
                      columnGap: 1,
                      // mr: 2,
                      p: 1,
                      color: '#444',
                      lineHeight: 1.3,
                      '&:hover': {
                        color: '#213e99',
                        backgroundColor: '#f0f2f9',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="FAQ’s about Form 941"
                      loading="lazy"
                      sx={{ mr: 1 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        // mr: 6.5,
                        fontWeight: 500,
                      }}
                    >
                      FAQ’s about Form 2290
                    </Typography>
                  </Box>
                </Link>
              </Stack>
              <Box
                sx={{
                  marginTop: '20px !important',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  textAlign: 'center',
                  // m: 'auto',
                  // display: 'flex',
                  // flexWrap: 'wrap',
                  margin: 'auto',
                  maxWidth: 250,
                  mb: 3,
                }}
              >
                <Button
                  // size="medium"
                  className="btn-resources"
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/`}
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    display: 'flex !important',
                    alignItems: 'center',
                    '&:hover, &:focus, &:active': {
                      backgroundColor: '#000 !important',
                      transform: 'scale(1.1)',
                      mb: 2,
                    },
                    // '&:hover .MuiSvgIcon-root': {
                    //   transform: 'rotate(-35deg)',
                    // },
                  }}
                >
                  Visit Our Resource Center
                  {/* <EastIcon sx={{ ml: 0.8 }} /> */}
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ md: 4, sm: 6, xs: 12 }}
            sx={{
              backgroundColor: '#ddf3f6  ',
              borderLeft: '1px solid #cce0e3',
              borderTopRightRadius: 16,
              borderBottomRightRadius: 16,
              pl: 2,
              pt: 1,

              '& .resoucres-new': {
                px: '0px !important',
                py: '0px !important',
              },
            }}
          >
            {/* <Paper
              variant="outlined"
              sx={{
                p: 2,
                mr: 2,
                mt: 1.5,
                borderRadius: 3,
              }}
              className="knownledge"
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { md: 18, sm: 17 },
                  color: '#333',
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Knowledge Center
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontSize: 13, color: '#637381', mt: -5 }}
                >
                  Walkthroughs, expert Q&As and Tutorials
                </Typography>

                <Box
                  component="img"
                  src="/assets/images/3d-images.webp"
                  alt="Knowledge Center"
                  loading="lazy"
                  width={179}
                  height={91}
                  sx={{
                    position: 'relative',
                    alignSelf: 'end',
                    justifyContent: 'end',

                    top: 24,
                    // left: 150,
                  }}
                />
              </Box>
            </Paper> */}

            <Paper
              variant="outlined"
              sx={{
                position: 'relative',
                mt: 1.5,
                mr: 1.5,
                p: 1.1,
                borderRadius: 2,
                border: '1px solid #e5e9f2',
                backgroundColor: '#fff',
                boxShadow: '0 3px 14px rgba(20, 35, 70, 0.05)',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 0.7,
                }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/comparison-icon.webp" />
                    <source srcSet="/assets/images/comparison-icon.png" />
                    <img
                      src="/assets/images/knowledge-base-icon.png"
                      alt="Comparison Icon"
                      loading="lazy"
                      width={30}
                      height={30}
                    />
                  </picture>
                </Box>

                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, fontSize: 15 }}
                >
                  Compare Alternatives
                </Typography>
              </Box>

              <Stack spacing={0.7}>
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-tax1099/`}
                  className="resoucres-new"
                  sx={{
                    display: 'block',
                    textDecoration: 'none',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      px: 1,
                      py: 0.75,
                      borderRadius: 1.2,
                      backgroundColor: '#eef6fd',
                      border: '1px solid transparent',
                      transition: 'all 0.25s ease',

                      '&:hover': {
                        backgroundColor: '#f0f2f9',

                        '& .comparison-text': {
                          color: '#213e99',
                        },

                        '& .comparison-arrow': {
                          transform: 'translateX(3px)',
                        },
                      },
                    }}
                  >
                    <Box
                      component="img"
                      className="comparison-arrow"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="What’s New in Form 941 for 2026 – Key Changes Explained"
                      loading="lazy"
                      sx={{
                        width: 16,
                        height: 16,
                        flexShrink: 0,
                        transition: 'transform 0.25s ease',
                      }}
                    />

                    <Typography
                      className="comparison-text"
                      sx={{
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#3d4654',
                        lineHeight: 1.4,
                        transition: 'color 0.25s ease',
                      }}
                    >
                      TaxZerone vs Tax1099
                    </Typography>
                  </Box>
                </Link>

                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/best-form-941-software/`}
                  className="resoucres-new"
                  sx={{
                    display: 'block',
                    textDecoration: 'none',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      px: 1,
                      py: 0.75,
                      borderRadius: 1.2,
                      backgroundColor: '#eef6fd',
                      border: '1px solid transparent',
                      transition: 'all 0.25s ease',

                      '&:hover': {
                        backgroundColor: '#f0f2f9',

                        '& .comparison-text': {
                          color: '#213e99',
                        },

                        '& .comparison-arrow': {
                          transform: 'translateX(3px)',
                        },
                      },
                    }}
                  >
                    <Box
                      component="img"
                      className="comparison-arrow"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="FAQ’s about Form 941"
                      loading="lazy"
                      sx={{
                        width: 16,
                        height: 16,
                        flexShrink: 0,
                        transition: 'transform 0.25s ease',
                      }}
                    />

                    <Typography
                      className="comparison-text"
                      sx={{
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#3d4654',
                        lineHeight: 1.4,
                        transition: 'color 0.25s ease',
                      }}
                    >
                      Best Form 941 E-File Software
                    </Typography>
                  </Box>
                </Link>
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-simpletrucktax/`}
                  className="resoucres-new"
                  sx={{
                    display: 'block',
                    textDecoration: 'none',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      px: 1,
                      py: 0.75,
                      borderRadius: 1.2,
                      backgroundColor: '#eef6fd',
                      border: '1px solid transparent',
                      transition: 'all 0.25s ease',

                      '&:hover': {
                        backgroundColor: '#f0f2f9',

                        '& .comparison-text': {
                          color: '#213e99',
                        },

                        '& .comparison-arrow': {
                          transform: 'translateX(3px)',
                        },
                      },
                    }}
                  >
                    <Box
                      component="img"
                      className="comparison-arrow"
                      src="/assets/images/new-arrow-icon.svg"
                      alt="FAQ’s about Form 941"
                      loading="lazy"
                      sx={{
                        width: 16,
                        height: 16,
                        flexShrink: 0,
                        transition: 'transform 0.25s ease',
                      }}
                    />

                    <Typography
                      className="comparison-text"
                      sx={{
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#3d4654',
                        lineHeight: 1.4,
                        transition: 'color 0.25s ease',
                      }}
                    >
                      TaxZerone vs SimpleTruckTax
                    </Typography>
                  </Box>
                </Link>
              </Stack>
            </Paper>

            <Link
              href="https://support.taxzerone.com/"
              target="_blank"
              className="resoucres-new"
              sx={{
                textDecoration: 'none',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 1.2,
                  py: 1,
                  borderRadius: 2,
                  background: '#fff',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',

                  justifyContent: 'space-between',
                  // gridTemplateColumns: 'auto auto ',
                  columnGap: 1,
                  // maxWidth: '100%',
                  // margin: 'auto',
                  mr: 2,
                  mt: 2,
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 25px',
                  },
                  '&:hover .MuiSvgIcon-root': {
                    transform: 'rotate(-35deg) !important',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/knowledge-base-icon.webp" />
                    <source srcSet="/assets/images/knowledge-base-icon.png" />
                    <img
                      src="/assets/images/knowledge-base-icon.png"
                      alt="Knowledge Base"
                      loading="lazy"
                      width={39}
                      height={39}
                    />
                  </picture>
                  <Box sx={{ ml: 1 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 15 }}
                    >
                      Knowledge Base
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        fontWeight: 400,
                        color: '#637381',
                        lineHeight: 1.3,
                      }}
                    >
                      Step-by-Step guide and FAQs
                    </Typography>
                  </Box>
                </Box>

                <EastIcon
                  sx={{
                    fontSize: 18,
                    color: '#2c2c2cff',
                    display: 'flex',
                    alignContent: 'end',
                    right: 0,
                  }}
                />
              </Paper>
            </Link>
            <Link
              href="https://blog.taxzerone.com/"
              target="_blank"
              className="resoucres-new"
              sx={{
                textDecoration: 'none',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 1.2,
                  py: 1,
                  borderRadius: 2,
                  background: '#fff',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',

                  justifyContent: 'space-between',
                  // gridTemplateColumns: 'auto auto ',
                  columnGap: 1,
                  // maxWidth: '100%',
                  // margin: 'auto',
                  mr: 2,
                  mt: 2,
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 25px',
                  },
                  '&:hover .MuiSvgIcon-root': {
                    transform: 'rotate(-35deg) !important',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/blog-icon.webp" />
                    <source srcSet="/assets/images/blog-icon.png" />
                    <img
                      src="/assets/images/blog-icon.png"
                      alt="Blog & Trending Topics"
                      loading="lazy"
                      width={39}
                      height={39}
                    />
                  </picture>
                  <Box sx={{ ml: 1 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 15 }}
                    >
                      Blog & Trending Topics
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        fontWeight: 400,
                        color: '#637381',
                        lineHeight: 1.3,
                      }}
                    >
                      Tax tips, industry changes and updated
                    </Typography>
                  </Box>
                </Box>

                <EastIcon
                  sx={{
                    fontSize: 18,
                    color: '#2c2c2cff',
                    display: 'flex',
                    alignContent: 'end',
                    right: 0,
                  }}
                />
              </Paper>
            </Link>
            <Typography
              variant="h6"
              sx={{
                fontSize: { md: 18, sm: 17 },
                color: '#333',
                fontWeight: 600,
                mb: 0.5,
                mt: 3,
              }}
            >
              Learning Hub
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                px: 1.2,
                py: 0,
                borderRadius: 2,
                background: 'transparent',
                border: 'none',
                display: 'flex',
                alignItems: 'center',

                justifyContent: 'space-between',
                // gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                // maxWidth: '100%',
                // margin: 'auto',
                mr: 2,
                mt: 0,
                transition: 'all 0.3s ease 0s',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <YouTubeIcon sx={{ fontSize: 42, color: '#FF0000' }} />
                <Box sx={{ ml: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 15 }}
                  >
                    YouTube Videos
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: 13,
                      fontWeight: 400,
                      color: '#637381',
                      lineHeight: 1.3,
                    }}
                  >
                    Walkthroughs, expert Q&As and Tutorials{' '}
                  </Typography>
                </Box>
              </Box>
            </Paper>
            <Box
              sx={{
                p: 2,
                mr: 0,
                mt: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                // width: '100%',
                '&:hover .MuiSvgIcon-root': {
                  transform: 'rotate(-35deg)',
                },
              }}
            >
              <Button
                variant="contained"
                className="btn-resources"
                sx={{
                  transition: 'all 0.3s ease 0s',
                  display: 'flex !important',
                  alignItems: 'center',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#000 !important',
                    boxShadow: '0 0 20px rgba(0,0,0,.25) !important',
                  },
                  '&:hover .MuiSvgIcon-root': {
                    transform: 'rotate(-35deg)',
                  },
                }}
                href="https://www.youtube.com/@taxzerone"
                target="_blank"
              >
                Explore All Videos <EastIcon sx={{ ml: 0.5 }} />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <>
      <ComingSoonPopup open={comingSoonOpen} setOpen={setComingSoonOpen} />
      <AppBar
        className="main-header"
        position="sticky"
        sx={{
          border: 0,
          padding: '0',
          marginBottom: '0px',
          top: 0,
          boxShadow:
            '0 4px 18px 0px rgba(0, 0, 0, 0.05), 0 7px 20px -5px rgba(0, 0, 0, 0.02)',
          zIndex: { xs: 100, lg: 1300 },
          backgroundColor: 'rgba(255,255, 255, .85)',
          backdropFilter: 'saturate(50%) blur(5px)',
        }}
        onClick={(e) => handleFormsMenuClose(e)}
      >
        <Toolbar sx={{ minHeight: 40 }}>
          <Box
            sx={{
              display: { md: 'block', lg: 'none' },
            }}
            alignItems="center"
          >
            <IconButton
              onClick={() => onSidebarOpen()}
              sx={{
                borderRadius: 0,
                minWidth: 'auto',
                border: 0,
                color: 'gray',
              }}
              aria-label="mobile menu"
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Container
            sx={{
              display: 'flex',
              px: { xs: 0, lg: 0 },
              minHeight: 64,
              maxWidth: '100% !important',
            }}
          >
            <Box
              sx={{
                flexGrow: { xs: '1', md: '1', lg: '0' },
                mt: 1,
                ml: { sm: 2, lg: 0 },
              }}
              alignItems="center"
              className="logo"
            >
              <Link
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                sx={{ textDecoration: 'none' }}
                alignItems="center"
              >
                <picture>
                  <source
                    srcSet="/assets/images/logo.webp"
                    className="mw-100"
                    width={150}
                    height={49}
                  />
                  <source
                    srcSet="/assets/images/logo.png"
                    className="mw-100"
                    width={150}
                    height={49}
                  />
                  <img
                    src="/assets/images/logo.png"
                    loading="lazy"
                    alt="TaxZerone - smart e-filing solution"
                    width={150}
                    height={49}
                  />
                </picture>
              </Link>
            </Box>
            <Box
              sx={{
                flexGrow: { md: '1', lg: '1', xs: '1' },
                display: { lg: 'inline', md: 'none', xs: 'none' },
                // pt: 1.5,
                alignSelf: 'center',
                ml: 1.5,
                justifyContent: 'center',
                // minHeight: 64,
                mt: '-2px',
              }}
              component="nav"
              aria-label="Main Navigation"
              className="main-menu"
            >
              <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                text="Home"
                className={getActiveClassName(['/'])}
              />
              <Box
                sx={{
                  display: 'inline-flex',
                  position: 'static !important',
                  minHeight: 66,
                  '& .Mui-selected-menu::before': { bottom: 0 },
                }}
                className={getSubMenuHoverClassName('forms-menu')}
                onMouseLeave={() => setSelectedSubMenu('')}
              >
                <Button
                  id="forms-button"
                  onClick={() => toggleSelectedSubMenu('forms-menu')}
                  aria-haspopup="true"
                  endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: 'transparent',
                    color: '#444',
                    fontSize: { sm: 12, md: 14 },
                    '&:hover, &:focus': {
                      backgroundColor: 'rgba(33, 62, 153, 0.04)',
                      color: '#213e99',
                    },
                  }}
                  className={`${getActiveClassName([
                    '/tax-extension',
                    '/excise-tax',
                    '/tax-exempt',
                    '/nonprofit-taxes',
                    '/employment-tax',
                    '/information-returns',
                    '/form-1099-series',
                    '/form-1099-state-filing',
                    '/form-w2-state-filing',
                    '/wage-tax-forms',
                    '/aca-forms',
                    '/business-tax',
                    '/request-form-w9-online-free',
                    '/request-form-w8ben-online-free',
                    '/form-8655',
                    '/efile-boi-report',
                  ])} ${formsMenuClass}`}
                >
                  Tax Forms
                </Button>
                <Box
                  className="tzo-dropdown"
                  sx={{
                    width: 'auto',
                    top: '88px !important',
                    left: '32px !important',
                    right: '32px !important',
                    '&:before': { left: 250 },
                    '&.tzo-dropdown': { pt: '0 !important' },
                  }}
                >
                  {formsList()}
                </Box>
              </Box>
              {/* <Button
                ref={tooleMenuAnchorRef}
                id="forms-button"
                aria-haspopup="true"
                className={`${getActiveClassName([
                  '/tax-extension',
                  '/excise-tax',
                  '/tax-exempt',
                  '/employment-tax',
                  '/information-returns',
                ])} ${formsMenuClass}`}
                onClick={handleFormsMenuToggle}
                endIcon={
                  <KeyboardArrowDownIcon
                    id="forms-button-end-icon"
                    sx={{ ml: -1 }}
                  />
                }
                sx={{
                  textTransform: 'none',
                  backgroundColor: 'transparent',
                  color: '#444',
                  '&:hover, &:focus': {
                    backgroundColor: 'rgba(33, 62, 153, 0.04)',
                    color: '#213e99',
                  },
                }}
              >
                Forms
              </Button> */}

              {/* <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}efile-boi-report/`}
                text="BOIR"
                className={`${getActiveClassName(['/efile-boi-report'])}`}
              /> */}

              <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}free-filing/`}
                text="FREE Filing"
                className={getActiveClassName(['/free-filing'])}
              />
              <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}pricing/`}
                text="Pricing"
                className={getActiveClassName(['/pricing'])}
              />
              <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-professionals/`}
                text="Tax Professionals"
                className={getActiveClassName(['/tax-professionals'])}
              />
              <Box
                sx={{
                  display: 'inline-flex',
                  minHeight: 66,
                  '& .Mui-selected-menu::before': { bottom: 0 },
                }}
                className={getSubMenuHoverClassName('tools-menu')}
                onMouseLeave={() => setSelectedSubMenu('')}
              >
                <Button
                  id="tools-menu"
                  onClick={() => toggleSelectedSubMenu('tools-menu')}
                  aria-haspopup="true"
                  endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: 'transparent',
                    color: '#444',
                    fontSize: { sm: 12, md: 14 },
                    '&:hover, &:focus': {
                      backgroundColor: 'rgba(33, 62, 153, 0.04)',
                      color: '#213e99',
                    },
                  }}
                  className={getActiveClassName([
                    '/resources',
                    '/contact-us',
                    '/tools/form-2290-tax-calculator',
                    '/tools/form-7004-due-date-calculator',
                  ])}
                >
                  Resources
                </Button>
                <Box
                  className="tzo-dropdown"
                  sx={{
                    width: {
                      lg: '1200px !important',
                      md: '1110px !important',
                    },
                    left: { lg: '-613px !important', md: '-550px !important' },
                    top: '90px !important',
                    '&:before': { left: 630 },
                    '&.tzo-dropdown': { pt: '0 !important', pb: 0 },
                    '& .MuiSvgIcon-root': {
                      transition: 'all 0.3s ease 0s',
                    },
                  }}
                >
                  {resourcesList()}
                </Box>
              </Box>
              <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}become-a-partner/`}
                text="Become a Partner"
                className={getActiveClassName(['/become-a-partner'])}
              />
              {process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && (
                <CustomButton
                  href={`${process.env.NEXT_PUBLIC_TZO_DEVELOPERSITE_URL}`}
                  target="_blank"
                  text="API"
                  //  className={getActiveClassName(['/become-a-partner'])}
                />
              )}
              {/* <CustomButton
                href="https://taxzerone.zeronevault.com/"
                text="ZeroneVault"
                className="Mui-menu"
                target="_blank"
              /> */}
              {/* <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}mobile-apps/`}
                text="Apps"
                className={getActiveClassName(['/mobile-apps'])}
              />
               <CustomButton
                href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}contact-us/`}
                text="Contact Us"
                className={getActiveClassName(['/contact-us'])}
                onMouseEnter={handleSupportMenuClose}
              /> */}

              {/* <Box
                sx={{
                  display: 'inline-flex',
                  minHeight: 66,
                  '& .Mui-selected-menu::before': { bottom: 0 },
                }}
                className={getSubMenuHoverClassName('support-menu')}
                onMouseLeave={() => setSelectedSubMenu('')}
              >
                <Button
                  id="support-menu"
                  onClick={() => toggleSelectedSubMenu('support-menu')}
                  aria-haspopup="true"
                  endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: 'transparent',
                    color: '#444',
                    fontSize: { sm: 12, md: 14 },
                    '&:hover, &:focus': {
                      backgroundColor: 'rgba(33, 62, 153, 0.04)',
                      color: '#213e99',
                    },
                  }}
                  className={getActiveClassName(['/contact-us'])}
                >
                  Support
                </Button>
                <Box
                  className="tzo-dropdown"
                  sx={{
                    width: 200,
                    top: '90px !important',
                    '&:before': { left: 25 },
                  }}
                >
                  <Box component={'ul'}>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}contact-us/`}
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link href="https://support.taxzerone.com/">
                        Knowledge Base
                      </Link>
                    </li>
                    <li>
                      <Link href="https://blog.taxzerone.com/" target="_blank">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="https://www.youtube.com/@taxzerone/videos"
                        target="_blank"
                      >
                        Videos
                      </Link>
                    </li>
                  </Box>
                </Box>
              </Box> */}
              {/* <CustomButton
                href="https://support.taxzerone.com/"
                text="Support"
                className="Mui-menu"
                onMouseEnter={handleToolsMenuClose}
              />
              <CustomButton
                href="https://blog.taxzerone.com/"
                text="Blog"
                className="Mui-menu"
                onMouseEnter={handleToolsMenuClose}
              /> */}
            </Box>
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              sx={{
                alignItems: 'center',
                display: { md: 'flex', sm: 'flex', xs: 'none' },
              }}
            >
              {/* <Box>
                <Tooltip
                  title="Access your tax documents securely through ZeroneVault — TaxZerone’s portal for electronic delivery and for taxpayers to e-sign authorization documents."
                  arrow
                >
                  <Button
                    size="small"
                    // className="secondary-outlined-btn"
                    sx={{
                      border: '1px solid #7d63ab',
                      borderRadius: 6,
                      px: '16px !important',
                      py: '3px !important',
                    }}
                    href="https://taxzerone.zeronevault.com/"
                    target="_blank"
                  >
                    <Box
                      component={'img'}
                      src="/assets/images/zv-logo.webp"
                      sx={{ maxWidth: 72, maxHeight: 24 }}
                      alt="ZeroneVault"
                    />
                  </Button>
                </Tooltip>
              </Box> */}
              <Button
                size="small"
                startIcon={<LockIcon />}
                className="secondary-outlined-btn"
                sx={{
                  borderRadius: '24px !important',
                  mr: '0 !important',
                }}
                href={`${
                  process.env.NEXT_PUBLIC_APPLICATION_URL
                }signin/?ref=${globalAssignRefName(router.pathname, false)}`}
              >
                Sign In
              </Button>
              <Button
                size="large"
                startIcon={<PersonIcon />}
                className="primary-btn"
                href={`${
                  process.env.NEXT_PUBLIC_APPLICATION_URL
                }signup/?ref=${globalAssignRefName(router.pathname, false)}`}
              >
                Sign Up
              </Button>
            </Stack>
          </Container>
          <Box
            sx={{
              display: { xs: 'block', sm: 'none' },
              width: 40,
            }}
            alignItems="end"
          >
            &nbsp;
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="top"
        open={showFormsMenu}
        onClose={handleFormsMenuClose}
        sx={{
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            boxSizing: 'border-box',
            maxHeight: 'calc(100% - 50px)',
          },
          marginTop: 6,
        }}
        PaperProps={{
          sx: { pt: 8 },
        }}
      >
        <Box className="tzo-formnav-inner" sx={{ pl: 3 }}>
          <Grid container spacing={0} sx={{ maxHeight: 750 }}>
            <Grid size={{ md: 3, lg: 2.2, xl: 1.8 }}>
              <Typography variant="h4" sx={{ mb: 2, mt: 2 }}>
                See what{' '}
                <span
                  style={{ fontWeight: 600, color: '#213e99', fontSize: 40 }}
                >
                  TaxZerone
                </span>{' '}
                <br />
                <span style={{ whiteSpace: 'nowrap' }}>can do for you!</span>
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: 13, lineHeight: 1.5 }}
              >
                Simplify IRS form filing and ensure that your forms are filed
                accurately and on time. Sign up now and enjoy a hassle-free
                filing experience!
              </Typography>
              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Button
                  startIcon={<PersonIcon />}
                  className="primary-btn"
                  sx={{ mx: 'auto !important' }}
                  href={`${
                    process.env.NEXT_PUBLIC_APPLICATION_URL
                  }signup/?ref=${globalAssignRefName(router.pathname, false)}`}
                >
                  Sign Up Now!
                </Button>
              </Box>
            </Grid>
            <Grid size={{ md: 5, lg: 6.8, xl: 6.7 }}>{formsList()}</Grid>
            <Grid
              size={{ md: 5, lg: 3, xl: 3.5 }}
              sx={{ backgroundColor: '#f6f6f4', minHeight: '100vh' }}
            >
              <Tooltip title="Close" arrow>
                <IconButton
                  onClick={handleFormsMenuClose}
                  sx={{ position: 'absolute', right: 20, p: 0.2, mt: 1 }}
                >
                  <CancelIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Box sx={{ px: 2, py: 1.5 }}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Quick Links
                </Typography>
                <Box
                  component="ul"
                  className="resource-link"
                  sx={{ listStyleType: 'none', p: 0, m: 0 }}
                >
                  <li>
                    <Link href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}faqs/`}>
                      <PlayArrowIcon />
                      FAQs
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}features/`}
                    >
                      <PlayArrowIcon />
                      Features
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}about-us/`}
                    >
                      <PlayArrowIcon />
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}free-filing/`}
                    >
                      <PlayArrowIcon />
                      FREE Filing
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_2290_SITE_URL}`}
                      target="_blank"
                    >
                      <PlayArrowIcon />
                      Form 2290
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}press-releases/`}
                    >
                      <PlayArrowIcon />
                      Press Releases
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}paystub-generator/`}
                    >
                      <PlayArrowIcon />
                      Paystub Generator
                    </Link>
                  </li>
                </Box>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, mt: 3, fontWeight: 600 }}
                >
                  Premium Features
                </Typography>
                <Box sx={{ display: 'flex' }}>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}features/click2file/`}
                    sx={{
                      backgroundColor: '#fff',
                      display: 'inline-block',
                      textDecoration: 'none',
                      borderRadius: 3,
                      p: 2,
                      mr: 2,
                      mb: 2,
                      minHeight: 150,
                      minWidth: 110,
                      textAlign: 'center',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        boxShadow: '0 0 20px rgba(0,0,0,.1)',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/click2file-icon.svg"
                      alt="Click2File"
                      sx={{ width: 70 }}
                    />
                    <Typography sx={{ fontWeight: 600 }} variant="body2">
                      Click2File
                    </Typography>
                  </Link>
                  <Link
                    href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/#auto-magic-2290`}
                    sx={{
                      backgroundColor: '#fff',
                      display: 'inline-block',
                      textDecoration: 'none',
                      borderRadius: 3,
                      p: 2,
                      mr: 2,
                      mb: 2,
                      minHeight: 150,
                      minWidth: 110,
                      textAlign: 'center',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        boxShadow: '0 0 20px rgba(0,0,0,.1)',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/images/auto-magic-icon.webp"
                      alt="AutoMagic2990"
                      sx={{ width: 70 }}
                    />
                    <Typography sx={{ fontWeight: 600 }} variant="body2">
                      AutoMagic
                      <br />
                      2290
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
